import React, { useState } from "react";
import "./userLogIn.scss";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";

const UserLogIn = ({ setShowLogIn, setShowConfirmationPayment }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const locationSeleced = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const navigateTorestaurants = (name) => {
    console.log(!sessionStorage.getItem("order"));
    if (!sessionStorage.getItem("order")) {
      navigate(`/restaurants`, { state: { name } });
    } else {
      if (typeof setShowLogIn === "function") {
        setShowLogIn(false);
      }
      if (typeof setShowConfirmationPayment === "function") {
        setShowConfirmationPayment(true);
      }
      sessionStorage.removeItem("order");
      navigate("/restaurant/restaurantView");
    }
  };
  const navigateToRegisterUser = () => {
    navigate("/user/creatuser");
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    await fetch("https://femez.onrender.com/API/user/logIn", {
      method: "POST",
      body: JSON.stringify({ email, password }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            const errorMessage = data.error || "An error occurred.";
            setMessage(errorMessage);
            // You can also throw an error here to handle it in the catch block below
            throw new Error(errorMessage);
          });
        } else {
          return response.json();
        }
      })
      .then((data) => {
        if (data.token) {
          const decodedToken = jwt_decode(data.token);
          console.log(decodedToken);
          if (decodedToken.role === "superadmin") {
            localStorage.setItem("token", data.token);
            console.log("superadmin");
            navigate("/admin/adminDashboard");
          } else if (decodedToken.role === "user") {
            console.log("user");
            localStorage.setItem("token", data.token);
            if (decodedToken.menubar_restaurant === "My restaurant") {
              localStorage.setItem("restaurant_existence", true);
            }
            const next = async () => {
              dispatch({
                type: "HANDLECHANGE",
                payload: {
                  location: decodedToken.address,
                },
              });
            };
            next();
            localStorage.setItem("token", data.token);
            navigateTorestaurants(data.name_surname);
          }
        }
      })
      .catch((error) => {
        console.log(message);
        console.error(error);
        console.log(error);
      });
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        <h1>Login</h1>
        <label>
          <p>Email</p>
          <input
            autoFocus={true}
            type="email"
            value={email}
            onChange={handleEmailChange}
            autoComplete="on"
          />
        </label>
        <label>
          <p>Password</p>
          <input
            type="password"
            value={password}
            onChange={handlePasswordChange}
            autoComplete="on"
          />
        </label>
        {message && (
          <div style={{ color: "red", padding: "0 0 0 10px" }}>{message}</div>
        )}
        <button type="submit">Login</button>
      </form>
      <div className="signUp-button" onClick={navigateToRegisterUser}>
        Create new account
      </div>
    </div>
  );
};

export default UserLogIn;
